export default function Loding ()
{
    return (
        
        <div className="spinner-container-submit">
            
            <div className="spinner"></div>
</div>
    );
}